import { TriangleExclamationIcon, CircleInfoIcon, StarsIcon, XmarkIcon } from '@revfluence/fresh-icons/solid/esm';
import React, { useState } from 'react';
import { Alert, AlertDescription } from '@frontend/shadcn/components/ui/alert';
import { Button } from '@frontend/shadcn/components/ui/button';

export interface IAlertProps {
  children?: React.ReactNode;
  type?: 'success' | 'error' | 'info' | 'unAuthorized';
}

// Alert styles to match Figma design using Shadcn Alert
const alertStyles = {
  success: 'bg-green-1 border-green-1 text-grey-6',
  unAuthorized: 'bg-yellow-1 border-yellow-1 text-grey-6',
  error: 'bg-[#e5e8eb] border-[#e5e8eb] text-[#16282d]', // Exact Figma colors
  info: 'bg-[#e5e8eb] border-[#e5e8eb] text-[#16282d]', // Exact Figma colors
};

const alertIcons = {
  success: <StarsIcon className="w-4 h-4 text-green-5" />,
  unAuthorized: <StarsIcon className="w-4 h-4 text-yellow-5" />,
  error: <TriangleExclamationIcon className="w-4 h-4 text-[#16282d]" />,
  info: <CircleInfoIcon className="w-4 h-4 text-[#16282d]" />,
};

const ContentPreviewAlert: React.FC<IAlertProps> = ({ children, type = 'error' }) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <Alert className={`rounded-2xl ${alertStyles[type]}`}>
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-3 flex-1">
          <div className="shrink-0">{alertIcons[type]}</div>
          <AlertDescription className="font-medium text-sm leading-6 text-left m-0">{children}</AlertDescription>
        </div>
        <Button
          variant="ghost"
          size="icon"
          onClick={handleClose}
          className="h-6 w-6 p-0 hover:opacity-70 hover:bg-transparent"
          aria-label="Dismiss"
        >
          <XmarkIcon className="h-3 w-3 text-[#16282d]" />
        </Button>
      </div>
    </Alert>
  );
};

export default ContentPreviewAlert;
